import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, Typography } from '@mui/material';

import { getPctgColor } from '»utils/pctgColors';

export const DataValue = styled('span', {
  shouldForwardProp: (prop) => prop !== 'value' && prop !== 'parent',
})(({ theme, value, parent }) => {
  const floatValue = parseFloat(value);

  const getVariationChar = () => {
    if (!Number.isNaN(floatValue)) {
      if (floatValue > 0) {
        return '"+"';
      }
      if (floatValue === 0) {
        return '""';
      }
    }
    return '""';
  };

  const getFontSize = (breakpoint) => {
    if (parent === 'card') return '22px';

    if (
      (parent === 'cardMobileList' || parent === 'cardMobileDetails') &&
      breakpoint === 'md'
    )
      return '28px';

    if (parent === 'dashboard') return '14px';

    if (parent === 'dashboardSmall') return '12px';

    return '24px';
  };

  return {
    fontSize: getFontSize(),
    fontWeight: 'bold',
    lineHeight: 'normal',
    color: getPctgColor(floatValue, theme),
    '&::before': {
      content: getVariationChar(),
    },
    '&::after': {
      content: !Number.isNaN(floatValue) && `"%"`,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: getFontSize('md'),
    },
  };
});

export const FontAwesomeIconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'value' && prop !== 'parent',
})(({ theme, value, parent }) => {
  const getIconSize = () => {
    if (parent === 'card') return '24px';

    if (parent === 'dashboard') return '18px';

    if (parent === 'dashboardSmall') return '16px';

    return '26px';
  };

  return {
    color: getPctgColor(value, theme),
    fontSize: getIconSize(),
    marginLeft:
      parent === 'dashboard' || parent === 'dashboardSmall' ? '2px' : '8px',
  };
});

export const VariationPctgContainer = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'parent',
})(({ parent }) => ({
  order: (parent === 'card' || parent === 'cardMobileDetails') && 2,
  textAlign:
    parent === 'dashboard' || parent === 'dashboardSmall' ? 'start' : 'end',
  lineHeight: 'normal',
  letterSpacing: 'normal',
}));
